/**
 * Cuisines
 *
 * Sub-view in the main filters view. Handles setting the data for the
 * cuisines to be rendered
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Filters.Sort');

OT.Redesign.Views.Filters.Sort = Backbone.ViewManager.BaseView.FilterGroup.extend({
    el: '#sort-filters',

    template: 'Redesign/Filters/_FilterSortOrder',

    beforeInitialize: function () {
        this.filterGroupId = 'sort-filters';
        this.title = Resources.Shared.Redesign.Filters.Label_Sort;
        this.filterGroupClass = 'filter-option filter-option-sort-orders';
        this.request = OT.Search.Data.get().Request;
    },

    beforeRender: function () {
        this.templateData = OT.Search.Data.get();

        this.additionalData = {
            title: this.title,
            filterGroupId: this.filterGroupId,
            filterGroupClass: this.filterGroupClass,
            request: this.templateData.Request
        };

        return this;
    },

    reInitializeSortDropdown: function() {
        OT.Common.Menus.bindMenu(this.$('.filters'));
    }
});
